import { useEditor } from "@craftjs/core";
import { faRedo, faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { Tooltip } from "../../input";

function UndoRedo() {
  const { query, actions } = useEditor();

  const undo = () => {
    if (query.history.canUndo()) {
      actions.history.undo();
    }
  };

  const redo = () => {
    if (query.history.canRedo()) {
      actions.history.redo();
    }
  };

  return (
    <div id="undo-redo" className="flex text-white mr-6">
      <Tooltip text={`Undo`} mouseEnterDelay={1} placement="top">
        <button
          disabled={!query.history.canUndo()}
          onClick={(e) => {
            undo();
          }}
          style={{
            color: query.history.canUndo() ? "black" : "rgb(156 163 175)",
          }}
          className={`undo-btn w-6 h-6 my-auto items-center flex duration-300 justify-center ${
            query.history.canUndo() ? "active" : ""
          }`}
        >
          <FontAwesomeIcon icon={faUndo} size="xs" />
        </button>
      </Tooltip>
      <Tooltip text={`Redo`} mouseEnterDelay={1} placement="top">
        <button
          disabled={!query.history.canRedo()}
          onClick={(e) => {
            redo();
          }}
          style={{
            color: query.history.canRedo() ? "black" : "rgb(156 163 175)",
          }}
          className={`redo-btn w-6 h-6 my-auto items-center flex duration-300 justify-center ${
            query.history.canRedo() ? "active" : ""
          }`}
        >
          <FontAwesomeIcon icon={faRedo} size="xs" />
        </button>
      </Tooltip>
    </div>
  );
}

export default UndoRedo;
